const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const {atSchool} = require("../core/vault/StateCursors");
const OpsSchool = require("./vault/OpsSchool");
const AT = require("../core/vault/ActionTypes");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const LoadState = require("../core/vault/util/LoadState");
const LoadGuard = require("../core/view/LoadGuard");
const PurchaseManage = require("./PurchaseManage");
const AccountBodyHeader = require("./AccountBodyHeader");
const AccountList = require("./AccountList");
const AccountClass = require("./AccountClass");
const AccountUser = require("./AccountUser");
const UpdateModal = require("./UpdateModal");
const CopyTable = require("./data/CopyTable");
const AddModal = require("./AddModal");
const ConfirmModal = require("./ConfirmModal");
const WarnModal = require("./WarnModal");
const Breadcrumbs = require("./Breadcrumbs");

const styles = require("./styles/AccountBody.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const schoolState = atSchool(vaultState).get();
			return {
				schoolState,
				mainLoad: OpsSchool.getAccountsLoad(schoolState),
				studentsLoad: OpsSchool.getAccountsStudentsLoad(schoolState),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "AccountBody",

		propTypes: {
			user: PT.object.isRequired,
			tab: PT.string,
			pageData: PT.object,

			// Injected by HOCs
			schoolState: PT.object.isRequired,
			mainLoad: PT.object.isRequired,
			studentsLoad: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				grade: null,
				year: null,
				displayedGrade: null,
				updateInfo: null, // object with modal type and identifier (e.g. student ID, class ID, etc.)
				addInfo: null,
				confirmInfo: null,
				warn: null,
				error: null,
				errorMoreInfo: null,
				status: null, // status for modals
				generatedUsernameObj: LoadState.loadInit(),
			};
		},

		vaultEvents: {
			generateSchoolUsernameSuccess: function(username) {
				const guo = _.extend({}, this.state.generatedUsernameObj, {username});
				this.setState({generatedUsernameObj: LoadState.loadSuccess(guo)});
			},
			generateSchoolUsernameFail: function(err, moreInfo) {
				this.setState({
					generatedUsernameObj: LoadState.loadError(
						this.state.generatedUsernameObj,
						err
					),
				});
			},
			generateSchoolUsernameReset: function(username) {
				this.setState({
					generatedUsernameObj: LoadState.loadRestart(
						this.state.generatedUsernameObj
					),
				});
			},
			schoolAccountActionSuccess: function() {
				this.updateModalInfo("success");
			},
			schoolAccountActionFail: function(err, moreInfo) {
				this.updateModalInfo("error", err, moreInfo);
			},
		},

		updateModalInfo(status, err, moreInfo) {
			const {updateInfo, addInfo, confirmInfo} = this.state;
			const isModalOpen = updateInfo || addInfo || confirmInfo;
			if (isModalOpen) {
				if (status === "success") {
					this.setState(this.resetState());
				} else if (status === "error") {
					this.setState({status: "error", error: err, errorMoreInfo: moreInfo});
				}
			}
		},

		resetState() {
			return {
				updateInfo: null,
				addInfo: null,
				confirmInfo: null,
				status: null,
				warn: null,
				error: null,
				errorMoreInfo: null,
				generatedUsernameObj: LoadState.loadInit(),
			};
		},

		showModal(modalType, contentType) {
			const newState = this.resetState();
			newState[modalType] = contentType;
			this.setState(newState);
		},

		closeModals() {
			this.setState(this.resetState());
		},

		updateValues(vals) {
			const {schoolState} = this.props;
			const {schoolID, classID, userID} = vals;
			let scope;
			if (userID) {
				scope = OpsSchool.isStaff(schoolState, userID) ? "staff" : "student";
				if (scope === "staff" && vals.hasOwnProperty("firstName")) {
					vals.displayName = vals.firstName;
				}
			} else if (classID) {
				scope = "class";
			} else if (schoolID) {
				scope = "school";
			} else {
				scope = "purchase";
			}
			this.props.dispatch({
				type: AT.UPDATE_SCHOOL_ACCOUNTS_SCOPE_REQUEST,
				userID,
				classID,
				schoolID,
				vals: _.omit(vals, ["schoolID", "classID", "userID"]),
				scope,
			});

			this.setState({status: "pending"});
		},

		// isTransfer is true if updating an existing staff's role.
		onAddOrTransfer(type, vals, isTransfer) {
			const purchaseID = _.get(this.props.schoolState, "accounts.purchase.id");
			const {userID, classID, schoolID} = vals;
			const staffTypes = ["purchaseAdmin", "schoolAdmin", "teacher"];
			if (isTransfer) {
				if (_.includes(staffTypes, type)) {
					this.props.dispatch({
						type: AT.UPDATE_SCHOOL_STAFF_ROLE_REQUEST,
						userID,
						classID,
						schoolID,
						purchaseID,
						role: type === "teacher" && !classID ? "auditor" : type,
						enabled: true,
					});
				} else if (type === "student") {
					this.props.dispatch({
						type: AT.UPDATE_SCHOOL_STUDENT_CLASS_REQUEST,
						purchaseID,
						userID,
						classID,
					});
				}
			} else if (type === "teacherAddClass") {
				this.props.dispatch({
					type: AT.UPDATE_SCHOOL_STAFF_ROLE_REQUEST,
					userID: _.get(this.props.pageData, "userID"),
					classID,
					role: "teacher",
					enabled: true,
					purchaseID,
				});
			} else if (type === "transfer") {
				this.props.dispatch({
					type: AT.UPDATE_SCHOOL_STUDENT_CLASS_REQUEST,
					userID: _.get(this.props.pageData, "userID"),
					classID,
					purchaseID,
				});
			} else {
				this.props.dispatch({
					type: AT.CREATE_SCHOOL_ACCOUNTS_SCOPE_REQUEST,
					classID,
					schoolID,
					purchaseID,
					vals: _.omit(vals, ["schoolID", "classID", "userID"]),
					scope: type,
				});
			}
			this.setState({status: "pending"});
		},

		onConfirm(confirmInfo) {
			const {type, schoolID, classID, userID} = confirmInfo;
			const isStaff = OpsSchool.isStaff(this.props.schoolState, userID);
			const purchaseID = _.get(this.props.schoolState, "accounts.purchase.id");
			// userID, schoolID, classID, role, isStaff
			const scopeInfo = _.omit(confirmInfo, "type");
			if (type === "remove") {
				this.props.dispatch({
					type: AT.UPDATE_SCHOOL_STAFF_ROLE_REQUEST,
					...scopeInfo,
					purchaseID,
					enabled: false,
				});
			} else if (classID || schoolID) {
				this.props.dispatch({
					type: AT.SET_ACTIVE_SCHOOL_ACCOUNTS_SCOPE_REQUEST,
					...scopeInfo,
					active: type === "activate",
				});
			} else if (userID) {
				if (
					type === "activate" &&
					isStaff &&
					!OpsSchool.doesStaffHaveRoles(this.props.schoolState, userID)
				) {
					// Set purchase-level auditor role if deactivating a staff without any other roles.
					this.props.dispatch({
						type: AT.UPDATE_SCHOOL_STAFF_ROLE_REQUEST,
						role: "auditor",
						userID,
						purchaseID,
						enabled: true,
					});
				} else {
					this.props.dispatch({
						type: AT.SET_ACTIVE_SCHOOL_ACCOUNTS_USER_REQUEST,
						...scopeInfo,
						purchaseID,
						active: type === "activate",
					});
				}
			}
			this.setState({status: "pending"});
		},

		loadMain: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ACCOUNTS_REQUEST,
			});
		},

		loadStudents: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ACCOUNTS_STUDENTS_REQUEST,
			});
		},

		generateUsername: function() {
			this.props.dispatch({
				type: AT.GENERATE_SCHOOL_USERNAME_REQUEST,
			});
		},

		updateFilter: function(filterType, val) {
			if (filterType === "gradeFilter") {
				this.setState({grade: parseInt(val)});
			} else if (filterType === "displayedGradeFilter") {
				this.setState({displayedGrade: parseInt(val)});
			} else if (filterType === "yearFilter") {
				this.setState({year: parseInt(val)});
			}
		},

		getModalProps(modalType) {
			const {inputProps, title} = CopyTable.getInputFieldCopy(modalType);
			const onUpdate = vals =>
				this.updateValues(_.extend(_.omit(modalType, "type"), vals));

			return {inputProps, title, onUpdate};
		},

		getAvailableFilterVals() {
			const {schoolState, pageData, tab, user} = this.props;
			const {schoolID} = pageData;

			// Don't show active students that were in past years of teacher classes if they only have teacher role.
			const isTeacherOnly = OpsSchool.isTeacherOnly(schoolState, user.userID);
			let grades = [];
			let years = [];
			let displayedGrades = [];
			if (tab === "classes" || tab === "students") {
				let classes = OpsSchool.getViewableClasses(
					schoolState,
					user.userID,
					tab === "students" && isTeacherOnly
				);
				if (schoolID) {
					const schoolClassIDs = _.get(schoolState, [
						"accounts",
						"schools",
						schoolID,
						"classIDs",
					]);
					classes = _.filter(classes, c => _.includes(schoolClassIDs, c.id));
				}

				grades = _.uniq(classes.map(c => c.gradeID)).sort();
				displayedGrades = _.uniq(classes.map(c => c.displayedGrade)).sort();
				const currentYear = OpsSchool.getPurchaseYear(schoolState);
				if (tab === "students" && isTeacherOnly) {
					years = [currentYear];
				} else {
					years = _.uniq(classes.map(c => c.year).concat(currentYear)).sort();
				}
			}

			return {grades, years, displayedGrades};
		},

		renderMain: function() {
			const {user, tab, pageData, schoolState} = this.props;
			const {classID, userID, schoolID} = pageData;
			const {
				updateInfo,
				grade,
				year,
				displayedGrade,
				addInfo,
				confirmInfo,
				status,
				warn,
				error,
				errorMoreInfo,
			} = this.state;

			let scope = "purchase";
			if (schoolID) scope = "school";
			if (classID) scope = "class";
			if (userID) scope = "user";

			const {grades, years, displayedGrades} = this.getAvailableFilterVals();
			const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
			const isSingleSchool = _.get(
				schoolState,
				"accounts.purchase.isSingleSchool"
			);

			// Default to the latest year
			let latestYear = year;
			if (!latestYear) {
				if (_.includes(years, purchaseYear)) latestYear = purchaseYear;
				else latestYear = _.max(years);
			} else if (years.length === 1) latestYear = years[0];
			else if (!_.includes(years, year)) latestYear = _.last(years);

			let contentBody;
			let deactivateEl;
			if (tab === "subscription" || classID || userID) {
				if (classID) {
					contentBody = (
						<AccountClass
							user={user}
							schoolState={schoolState}
							classID={classID}
							showModal={this.showModal}
						/>
					);
				} else if (userID) {
					contentBody = (
						<AccountUser
							user={user}
							schoolState={schoolState}
							userID={userID}
							showModal={this.showModal}
						/>
					);
				} else {
					contentBody = (
						<PurchaseManage user={user} schoolState={schoolState} />
					);
				}
			} else {
				const innerContent = OpsSchool.isTeacherWithoutClasses(
					schoolState,
					user.userID
				) ? (
					<div className={styles.unassignedMessage}>
						{CopyTable.getUnassignedContactAdminCopy()}
					</div>
				) : (
					<AccountList
						user={user}
						tab={tab}
						pageData={pageData}
						schoolState={schoolState}
						showModal={this.showModal}
						grade={grade}
						year={latestYear}
						displayedGrade={displayedGrade}
					/>
				);
				contentBody = <div className={styles.tabContent}>{innerContent}</div>;

				if (schoolID) {
					const isActive = _.get(schoolState, [
						"accounts",
						"schools",
						schoolID,
						"active",
					]);

					const activeText = isActive ? "deactivate" : "activate";

					const role = OpsSchool.getBestRoleForSchool(
						schoolState,
						user.userID,
						schoolID
					);
					const hasPerms = role === "purchaseAdmin" || role === "schoolAdmin";

					deactivateEl =
						hasPerms && !isSingleSchool ? (
							<div
								className={isActive ? styles.deactivate : styles.activate}
								onClick={() =>
									this.showModal("confirmInfo", {
										type: isActive ? "deactivate" : "activate",
										schoolID,
									})
								}
							>
								{`${activeText} school`}
							</div>
						) : null;
				}
			}

			let modalEl;
			if (warn) {
				modalEl = <WarnModal onClose={this.closeModals} type={warn} />;
			} else if (updateInfo) {
				const modalProps = this.getModalProps(updateInfo);
				let updateFor;
				if (updateInfo.userID) {
					updateFor = OpsSchool.getUser(schoolState, updateInfo.userID);
				} else if (updateInfo.classID) {
					const classInfo = _.get(
						schoolState,
						["accounts", "classes", updateInfo.classID],
						{}
					);
					updateFor = {
						displayName: classInfo.displayName,
						classURL: classInfo.classURL,
					};
				} else if (updateInfo.schoolID) {
					updateFor = {
						displayName: _.get(schoolState, [
							"accounts",
							"schools",
							updateInfo.schoolID,
							"displayName",
						]),
					};
				}
				modalEl = (
					<UpdateModal
						identifier={
							scope +
							(schoolID || classID || userID || "") +
							"-" +
							(updateInfo.schoolID ||
								updateInfo.classID ||
								updateInfo.userID ||
								"")
						}
						updateFor={updateFor}
						{...modalProps}
						onClose={this.closeModals}
						status={status}
						error={error}
					/>
				);
			} else if (addInfo) {
				modalEl = (
					<AddModal
						user={user}
						type={addInfo}
						onClose={this.closeModals}
						onAddOrTransfer={this.onAddOrTransfer}
						generatedUsernameObj={this.state.generatedUsernameObj}
						generateUsername={this.generateUsername}
						userID={userID}
						classID={classID}
						schoolID={schoolID}
						schoolState={schoolState}
						status={status}
						error={error}
						errorMoreInfo={errorMoreInfo}
					/>
				);
			} else if (confirmInfo) {
				modalEl = (
					<ConfirmModal
						typeProps={confirmInfo}
						onConfirm={this.onConfirm}
						schoolState={schoolState}
						onClose={this.closeModals}
						status={status}
						error={error}
					/>
				);
			}

			const isPurchaseActive = OpsSchool.isPurchaseActive(schoolState);
			const notice = !isPurchaseActive ? (
				<div className={styles.notice}>
					{CopyTable.getPurchaseInactiveCopy(
						_.get(schoolState, "accounts.purchase.expiredAt"),
						OpsSchool.isPurchaseAdmin(schoolState, user.userID)
					)}
				</div>
			) : null;

			return (
				<div className={styles.main}>
					{notice}
					<div className={styles.top}>
						<Breadcrumbs
							user={user}
							pageData={pageData}
							schoolState={schoolState}
						/>
					</div>
					<div className={styles.content}>
						<AccountBodyHeader
							user={user}
							tab={tab}
							pageData={pageData}
							schoolState={schoolState}
							updateFilter={this.updateFilter}
							filters={{grade, year: latestYear, displayedGrade}}
							availableGrades={grades}
							availableYears={years}
							availableDisplayedGrades={displayedGrades}
							showModal={this.showModal}
							shouldShowFilters={
								!OpsSchool.isTeacherWithoutClasses(schoolState, user.userID)
							}
						/>
						{contentBody}
						{modalEl}
						{deactivateEl}
					</div>
				</div>
			);
		},

		render: function() {
			const {tab, pageData} = this.props;
			const {classID, userID} = pageData;

			const renderFunc =
				tab === "students" || tab === "subscription" || classID || userID
					? () => {
							return (
								<LoadGuard
									identifier="accountsMainStudents"
									status={this.props.studentsLoad}
									requestLoad={this.loadStudents}
									loadingView={"logo"}
									logoColorType={"color"}
									errorView="refreshOffice"
									renderLoaded={this.renderMain}
								/>
							);
					  }
					: this.renderMain;

			return (
				<LoadGuard
					identifier="accountsMain"
					status={this.props.mainLoad}
					requestLoad={this.loadMain}
					loadingView={"logo"}
					logoColorType={"color"}
					errorView="refreshOffice"
					renderLoaded={renderFunc}
				/>
			);
		},
	})
);
